module.exports = "app.service(\"ExternalUnitType\",[\"Resty\",function(Resty){return Resty(\"external_unit_types\",\"dictionaries\");}]);"